<template>
	<div>
		<loading id="spinner" :active="false" :can-cancel="false" :is-full-page="true"></loading>
		<div class="row">
			<div class="input-field col s10">
				<i class="material-icons prefix ">search</i>
				<input id="search" type="text" class="validate" v-model="filterTerm" v-on:keyup.enter="pagina = 1;verifyInscricaos();" placeholder="Nome, Ação, unidade, centro">
				<label for="search">Pesquisar</label>
			</div>
			<div class="input-field col s2">
				<button class="btn teal" @click="pagina = 1;verifyInscricaos();"><i class="material-icons left">search</i><small>Pesquisar</small></button>
			</div>
		</div>

		<div class="row">
			<div class="col s12 m12 l12 xl12">
				<table>
					<thead>
						<tr>
							<th>
								Ação
								<a class="left" href="#" @click="toggleOrder($event, 'acao.titulo')">
									<i class="material-icons" v-bind:class="{ 'red-text': sortPropertyTitulo }" >sort</i>
								</a>
							</th>
							<th>
								Coordenador
								<a class="left" href="#" @click="toggleOrder($event, 'usuario.name')">
									<i class="material-icons" v-bind:class="{ 'red-text': sortPropertyNome }" >sort</i>
								</a>
							</th>
							<th>
								Modalidade
								<a class="left" href="#" @click="toggleOrder($event, 'acao.modalidade')">
									<i class="material-icons" v-bind:class="{ 'red-text': sortPropertyModalidade }" >sort</i>
								</a>
							</th>
							<th>
								Nota
								<!-- TODO a class="left" href="#" @click="toggleOrder($event, 'nota_final')">
									<i class="material-icons" v-bind:class="{ 'red-text': sortPropertyNota }" >sort</i>
								</a-->
							</th>
							<th>
								Bolsas de Extensão
							</th>
							<th>
								Meses
								<a class="left" href="#" @click="toggleOrder($event, 'quantidade_meses')">
									<i class="material-icons" v-bind:class="{ 'red-text': sortPropertyMeses }" >sort</i>
								</a>
							</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(inscricao, index) in filteredInscricaos">
							<td>
								<a :href="'/inscricaos/ver/' + inscricao.id">
									{{inscricao.acao.titulo}}
								</a>
							</td>
							<td>
								<a :href="'/usuario/' + inscricao.users_id">
									{{inscricao.usuario.name}}
								</a>
							</td>
							<td>
								{{inscricao.acao.modalidade}}
							</td>
							<td>
								{{inscricao.nota_final}}
							</td>
							<td>
                                <p v-for="(bolsa, bolsa_i) in inscricao.bolsas_extensao" :key="bolsa_i">
                                    <span style="font-weight: bold;">Bolsa de Extensão {{ bolsa.codigo }}:</span>
                                    <span>{{ bolsa.quantidade_bolsas_selecionadas }} bolsa(s)</span>
                                </p>
							</td>
							<td>
								{{inscricao.quantidade_meses}}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<div class="row">
			<div class="input-field col s6 m6 l3 xl3">
				<button type="submit" class="btn" @click="anterior()" :disabled='pagina <= 1'><i class="material-icons left">arrow_back_ios</i>Anterior</button>
			</div>
			<div class="input-field col s6 m6 l3 xl3">
				<button type="reset" class="btn" @click="proximo()" :disabled='pagina >= total'><i class="material-icons right">arrow_forward_ios</i>Próximo</button>
			</div>
		</div>

		<hr>
		<div class="row">
			<div class="input-field col s12 m16 l6 xl6">
				<h5>Total de Bolsas Solicitadas: {{solicitadas}}</h5>
			</div>
			<div class="input-field col s12 m16 l6 xl6">
				 <h5>Total de Bolsas Concedidas: {{concedidas}}</h5>
			</div>
		</div>

	</div>
</template>

<script>
	import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    export default {
		name: "VueBolsasDistribuicaoList",
		props: [
			'edital',
			'solicitadas',
			'concedidas',
			'edit'
		],
		components: {
			Loading
		},
		data () {
			return {
				listaInscricaos: [],
				ed: JSON.parse(this.edital),
				sortDirection: 'desc',
				filterTerm: '',
				sortProperty: 'nota',
				sortPropertyTitulo: false,
				sortPropertyNome: false,
				sortPropertyModalidade: false,
				sortPropertyBolsas: false,
				sortPropertyMeses: false,
				sortPropertyNota: true,
				maxBolsas: 0,
				pagina: 1,
				total: 0
			}
		},
		computed: {
			filteredInscricaos: function () {
				var self = this
				return _.orderBy(self.listaInscricaos, this.sortProperty, this.sortDirection)
			}
		},
		methods: {
			toggleOrder(ev, field) {
				ev.preventDefault()
				if (this.sortProperty == field) {
					if (this.sortDirection == 'asc')
						this.sortDirection = 'desc'
					else
						this.sortDirection = 'asc'
				} else {
					this.iconsColor(this.sortProperty, false)
					this.iconsColor(field, true)
					this.sortProperty = field
					this.sortDirection = 'asc'
				}
			},
			iconsColor(field, value) {
				switch (field) {
					case 'acao.titulo':
					  this.sortPropertyTitulo = value
					  break;
					case 'usuario.name':
					  this.sortPropertyNome = value
					  break;
					case 'acao.modalidade':
					  this.sortPropertyModalidade = value
					  break;
					/*case 'nota_final':
					  this.sortPropertyNota = value
					  break;*/
					case 'quantidade_cotas':
					  this.sortPropertyBolsas = value
					  break;
					case 'quantidade_meses':
					  this.sortPropertyMeses = value
					  break;
					default:
				}
			},
			verifyInscricaos: function () {
				if (this.filterTerm.length < 3 && this.filterTerm.length > 0) {
					showMsg('Para usar o filtro tem que ter pelo menos 3 caracteres', 0);
				} else {
					var estilo = document.getElementById('spinner').style;

					estilo.display = null;
					this.$http.get('/api/bolsas/distribuicao' + (this.filterTerm.length >= 3? '/' + this.filterTerm : '') + '?page' + '=' + this.pagina).then((req) => {this.listaInscricaos = req.body.data; this.total = req.body.last_page;estilo.display = 'none';})
				}
			},
			proximo: function () {
				this.pagina++;
				this.verifyInscricaos();
			},
			anterior: function () {
				this.pagina--;
				this.verifyInscricaos();
			}
		},
		mounted() {
			this.verifyInscricaos();
		}
	}
</script>